import * as validator from 'validator';
import { UserAuth } from '../custom-types';
import { DEFAULT_USER_AUTH, DEFAULT_PLAYER_AUTH } from './Consts';

/** Handle form validation for the login form
 * @param email - user's auth email
 * @param password - user's auth password
 * @param setError - function that handles updating error state value
 */
export const validateLoginForm = (
  email: string,
  password: string,
  setError: (error: string | null) => void,
): boolean => {
  // Check for undefined or empty input fields
  if (!email || !password) {
    setError('Please enter a valid email and password.');
    return false;
  }

  // Validate email
  if (!validator.isEmail(email)) {
    setError('Please enter a valid email address.');
    return false;
  }

  return true;
};

/** Return user auth from local storage value */
export const getStoredUserAuth = (): UserAuth => {
  const auth = window.localStorage.getItem('UserAuth');
  if (auth) {
    return JSON.parse(auth);
  }
  return DEFAULT_USER_AUTH;
};

export const getStoredPlayer = (): any => {
  const selectedPlayer = window.localStorage.getItem('SelectedPlayer');
  if (selectedPlayer) {
    return JSON.parse(selectedPlayer);
  }
  // The "no player chosen" value, not null. PlayerView reads selectedPlayerAuth.name while
  // it waits for the player to load, so returning null made a direct visit to /player/:id -
  // or a reload after the browser cleared its storage - throw and leave a white screen on a
  // screen nobody is standing next to. deselectPlayer already uses this value for the same
  // state, and getStoredUserAuth above already returns its default rather than null.
  return DEFAULT_PLAYER_AUTH;
};

export const getStoredUser = (): any => {
  const currentUser = window.localStorage.getItem('User');
  if (currentUser) {
    return JSON.parse(currentUser);
  }
  return null;
};

/**
 * API Request handler
 * @param url - api endpoint
 * @param method - http method
 * @param bodyParams - body parameters of request
 */

export const apiRequest = async (url: string, method: string, bodyParams?: any): Promise<any> => {
  const response = await fetch(url, {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: bodyParams ? JSON.stringify(bodyParams) : undefined,
  });

  return await response.json();
};

export function diff<T>(lhs: T, rhs: T): (keyof T)[] {
  return (Object.keys(lhs).filter(k => (lhs as any)[k] !== (rhs as any)[k]) as any) as (keyof T)[];
}
